import { FormFieldBase } from './form-field-base.model';

export interface SignatureAttributeConfigInterface {
  key: string;
  label: string;
  order: number;
  enabled: boolean;
}
export class SignatureAttributeConfig implements SignatureAttributeConfigInterface {
  key: string;
  label: string;
  order: number;
  enabled: boolean;
  constructor(data: SignatureAttributeConfigInterface) {
    this.key = data && data.key;
    this.label = data && data.label;
    this.order = data && data.order;
    this.enabled = data && data.enabled;
  }
}
export interface SignatureConfigInterface {
  markupId: string;
  isForward?: boolean;
  attributes: SignatureAttributeConfigInterface[];
}

export class SignatureConfig implements SignatureConfigInterface {
  markupId: string;
  isForward?: boolean;
  attributes: SignatureAttributeConfig[];

  constructor(data: SignatureConfigInterface) {
    this.markupId = data && data.markupId;
    this.isForward = data?.isForward;
    // this.attributes = SignatureConfig.conbineAttributes(data && data.attributes);
    this.attributes = data.attributes;
  }
  static attributeDefaults(): SignatureAttributeConfig[] {
    return [
      {
        key: 'signer_name',
        label: 'Signer Name',
        order: 1,
        enabled: false,
      },
      {
        key: 'signing_date',
        label: 'Signing Date',
        order: 2,
        enabled: false,
      },
    ].map(item => new SignatureAttributeConfig(item));
  }
  static conbineAttributes(attributes: SignatureAttributeConfigInterface[] = []): SignatureAttributeConfig[] {
    const attributeAvailables = SignatureConfig.attributeDefaults();
    attributeAvailables.forEach(item => {
      const selected = attributes.find(attribute => attribute.key === item.key);
      if (selected) {
        item.order = selected.order;
        item.enabled = selected.enabled;
      }
    });
    return attributeAvailables;
  }
}

export class SignatureField extends FormFieldBase {
  constructor(options: any = {}) {
    super(options);
    this.fieldType = 'signatureField';
    this.label = options['label'] ? options['label'] : '';
    this.controlType = 'signature';
    this.config = new SignatureConfig(options['config']);
    this.count = 1;
  }
  override config: SignatureConfig;

  override getPlaceHolder(): string {
    return '';
  }

  override getMarkerName(): string {
    return this.key;
  }
}

export interface SignatureDataInterface {
  id: string;
  uuid?: string;
  role: string;
}

export class SignatureData implements SignatureDataInterface {
  id: string;
  uuid: string;
  role: string;

  constructor(data: SignatureDataInterface) {
    this.id = data.id;
    this.uuid = data.uuid || '';
    this.role = data.role;
  }
}
